import { USER_GENDER } from 'cpool-constants';
import { z } from 'zod';

import { schemaEuropacePartnerId } from '../../LoanRequest/Europace';
import { Phone } from '../../utils/phone.utils';
import { schemaId } from '../../utils/schema.utils';

export const schemaUserCommon = z.object({
    absence: z
        .array(
            z.object({
                absenceFrom: z.coerce.date(),
                absenceUntil: z.coerce.date(),
                delegateId: schemaId,
                eventId: schemaId,
                reason: z.optional(z.string().min(1)),
            }),
        )
        .optional()
        .default([]),
    avatar: z.string().optional(),
    certData: z.string().nullish(),
    certFileName: z.string().nullish(),
    certKey: z.string().nullish(),
    createdBy: z.string().trim().min(1),
    deactivated: z.boolean().optional(),
    delegateId: schemaId.nullish(),
    email: z.string().email(),
    // since this is used in the User_Created event we cannot change the entire object to something different without breaking backwards compatibility
    europace: z
        .object({
            partnerId: schemaEuropacePartnerId.nullable(),
            partnerIdStarpool: schemaEuropacePartnerId.nullish().default(null),
        })
        .nullable()
        .default(null),
    firstName: z.string().trim().min(1),
    gender: z.nativeEnum(USER_GENDER),
    id: schemaId.optional(),
    lastName: z.string().trim().min(1),
    phone: Phone.nullish(),
    pid: z.string().trim().min(1).nullish(),
    procheckId: z.string().trim().min(1).nullable().default(null),
    registered: z.boolean().optional(),
    secret: z.string().optional(),
    signatureId: schemaId.nullish(),
    smtp: z
        .object({
            password: z.string().min(1),
            user: z.string().min(1),
        })
        .nullable(),
    state: z.number().optional(),
    title: z.string().min(1),
    tmpSecret: z.string().nullish(),
});
